import firebase from "firebase/app";

// freshpaint.canny.io AppID
const AppID = "61b004081f9ab068dfa542a8";

export function CannyRedirect() {
  (function (w, d, i, s) {
    function l() {
      if (!d.getElementById(i)) {
        var f = d.getElementsByTagName(s)[0],
          e = d.createElement(s);
        (e.type = "text/javascript"),
          (e.async = !0),
          (e.src = "https://canny.io/sdk.js"),
          f.parentNode.insertBefore(e, f);
      }
    }
    if ("function" != typeof w.Canny) {
      var c = function () {
        c.q.push(arguments);
      };
      (c.q = []),
        (w.Canny = c),
        "complete" === d.readyState
          ? l()
          : w.attachEvent
          ? w.attachEvent("onload", l)
          : w.addEventListener("load", l, !1);
    }
  })(window, document, "canny-jssdk", "script");

  var userName = firebase.auth().currentUser.email;
  firebase.auth().currentUser.providerData.forEach((providerData) => {
    if (providerData.displayName !== null) {
      userName = providerData.displayName;
    }
  });

  function openWindow() {
    window.open("https://freshpaint.canny.io/integration-requests");
  }

  Canny(
    "identify",
    {
      appID: AppID,
      user: {
        email: firebase.auth().currentUser.email,
        id: firebase.auth().currentUser.uid,
        name: userName,
      },
    },
    openWindow
  );
}
